// @flow

/**
 * @deprecated Please import the component from '../../../../commons/display-brand'
 * */
export { DisplayBrand } from '../../../../commons/display-brand';
